(function() {
  function toggleLeyenda() {
    const bloque = document.getElementById('custom-text-selector');
    if (!bloque) return;

    const leyendaInput = document.querySelector('input[type="radio"]:checked[name*="Leyenda:"]');
    const valor = leyendaInput ? leyendaInput.value.toLowerCase() : '';
    const esConTexto = valor === 'con texto';

    bloque.style.display = esConTexto ? 'block' : 'none';

    if (esConTexto) {
      const primero = bloque.querySelector('input[type="radio"]');
      if (primero && !bloque.querySelector('input[type="radio"]:checked')) {
        primero.checked = true;
        const btn = primero.closest('label')?.querySelector('.leyenda-btn');
        if (btn) {
          btn.style.borderColor = '#000000';
          btn.style.backgroundColor = '#000000';
          btn.style.color = '#ffffff';
        }
      }
    }

    bloque.querySelectorAll('input[type="radio"]').forEach(i => {
      i.required = esConTexto;
      if (!esConTexto) i.checked = false;
    });

    if (!esConTexto) {
      bloque.querySelectorAll('.leyenda-btn').forEach(b => {
        b.style.borderColor = '#e6e6e6';
        b.style.backgroundColor = '';
        b.style.color = '';
      });
    }
  }

  window.addEventListener('load', function() {
    toggleLeyenda();
    document.addEventListener('change', function(e) {
      if (e.target.name !== 'properties[Leyenda]') toggleLeyenda();
    });
  });

  // Clicks en botones de leyenda
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.leyenda-btn');
    if (btn) {
      const input = btn.closest('label')?.querySelector('input[type="radio"]');
      if (!input) return;
      input.checked = true;
      document.dispatchEvent(new CustomEvent('leyenda:selected', { detail: { valor: input.value } })); 
      document.querySelectorAll('.leyenda-btn').forEach(b => {
        b.style.borderColor = '#e6e6e6';
        b.style.backgroundColor = '';
        b.style.color = '';
      });
      btn.style.borderColor = '#000000';
      btn.style.backgroundColor = '#000000';
      btn.style.color = '#ffffff';
      return;
    }

    // Interceptar botón de agregar al carrito
    const boton = e.target.closest('form[action="/cart/add"] button[type="submit"], form[action="/cart/add"] [name="add"]');
    if (!boton) return;

    const bloque = document.getElementById('custom-text-selector');
    const esVisible = bloque && bloque.style.display !== 'none';
    if (!esVisible) return;

    const leyendaChecked = document.querySelector('#custom-text-selector input[type="radio"]:checked');
    if (!leyendaChecked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert('Por favor selecciona una leyenda antes de continuar.');
      return;
    }

    const form = boton.closest('form[action="/cart/add"]');
    if (form) {
      let hidden = form.querySelector('input[name="properties[Leyenda]"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'properties[Leyenda]';
        form.appendChild(hidden);
      }
      hidden.value = leyendaChecked.value;
    }
  });

})(); 

